import React, { useCallback } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button';

import { useButtonEventHandler } from '../hooks/analytics-handlers/useButtonEventHandler';
import { analytics } from '../experimentConstants';
import { useGetOSBLink } from '../hooks/useGetOSBLink';
import { useExperimentInfo } from '../store/experimentInfoStore';

const i18n = defineMessages({
	ctaAddPaymentDetails: {
		id: 'end-of-trial-payment-modals.cta.add-payment-details',
		defaultMessage: 'Add payment details',
		description: 'Add payment details button text',
	},
});

export const AddPaymentDetailsButton = ({ closeModal }: { closeModal: () => void }) => {
	const { eventHandler } = useButtonEventHandler();
	const { osbLink } = useGetOSBLink();
	const { cohort } = useExperimentInfo();

	const handleOnClick = useCallback(() => {
		eventHandler({
			actionSubjectId: 'trialActionComponent',
			userAction: 'addBilling',
			type: 'info',
			experiment: analytics.SOURCE,
			cohort,
		});
		window.open(osbLink, '_blank');
		closeModal();
	}, [closeModal, cohort, eventHandler, osbLink]);

	return (
		<Button appearance="primary" onClick={handleOnClick}>
			<FormattedMessage {...i18n.ctaAddPaymentDetails} />
		</Button>
	);
};
